import { backgroundColors } from '@/assets';

export const NAVBAR_MENU_ITEM_BORDER_DEFAULTS = {
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
  borderRadius: '8px',
};

export const NAVBAR_MENU_ITEM_LINK_DEFAULTS_V2 = {
  padding: '2px 4px 2px 4px',
  margin: '0px',
  overflow: 'hidden',
  background: 'none',
  color: '#000',
  fontSize: '16px',
  fontWeight: '500',
  fontFamily: 'Inter',
  letterSpacing: '0px',
};

export const NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2 = {
  padding: '8px',
  margin: '0px',
  overflow: 'hidden',
  background: 'none',
  color: '#a3a3a3',
  fontFamily: 'Inter',
  letterSpacing: '0px',
  iconSize: '16px',
};

export const NAVBAR_MENU_ITEM_LOGO_DEFAULTS_V2 = {
  width: 'auto',
  height: '36px',
  padding: '0px',
  background: 'transparent',
  gap: '4px',
};

export const NAVBAR_MENU_ITEM_BUTTON_DEFAULTS_V2 = {
  padding: '4px 8px 4px 8px',
  margin: '0px',
  overflow: 'hidden',
  background: backgroundColors.purple,
  color: '#fff',
  fontFamily: 'Inter',
  fontSize: '16px',
  letterSpacing: '0px',
  fontWeight: '500',
  iconColor: '#FFFFFF',
  iconPlacement: 'left',
  iconSize: '24px',
};
